// extracted by mini-css-extract-plugin
export default {"menu":"article-more-menu_menu__d0MqO","divider":"article-more-menu_divider__iJgvB","delete":"article-more-menu_delete__Sfuf7"};